var _line, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 10,
    viewBox: "0 0 348 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 341,
    y1: 6,
    x2: 5,
    y2: 6.00003,
    stroke: "#C0C0C0",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 6,
    x2: 5,
    y2: 6,
    stroke: "#FF9900",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 5,
    r: 5,
    transform: "rotate(-90 343 5)",
    fill: "#C0C0C0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 5,
    r: 5,
    transform: "rotate(-90 174 5)",
    fill: "#FF9900"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "rotate(-90 5 5)",
    fill: "#FF9900",
    stroke: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage2);
export default __webpack_public_path__ + "static/media/stage2.d47227f029b958f2fa73cd4c2de49223.svg";
export { ForwardRef as ReactComponent };